<template>
  <custom-form :action="newNetworkUrl" @submitted="$emit('added', $event)">
    <custom-select name="type" :items="missingTypes" label="Network type" />

    <custom-button block raised color="primary">
      <v-icon>mdi-tab-plus</v-icon>
      Add network
    </custom-button>
  </custom-form>
</template>
<script>
import difference from "lodash/difference";
import capitalize from "lodash/capitalize";
export default {
  props: {
    company: {
      required: true,
      type: Object,
    },
  },
  computed: {
    missingTypes() {
      const existing = this.company.networks.map(({ type }) => type);
      return difference(["aggregator", "distributor", "sub-distributor"], existing);
    },
    newNetworkUrl() {
      return `/api/v1/companies/${this.company.id}/networks`;
    },
  },

  methods: {
    capitalize,
  },
};
</script>
